import { Component, Input } from '@angular/core';
import { WebStatsStatus, WebStatsStatusLabels } from '../../domain/web-stats-status.enum';
import { KnDomainWebStatsDialogComponent } from './kn-domain-webstats-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Domain } from '../../domain/domain.model';

@Component({
  selector: 'cm-web-stats-status-icon',
  template: `
    <!--<cm-popover #popover [enabled]="showDetailsPopover">-->
    <!--<cm-popover-action>-->
    <!--<span *ngIf="status === WebStatsStatus.PENDING" class="web-stats-icon text-warning">-->
    <!--<i class="fas fa-minus" aria-hidden="true"></i>-->
    <!--</span>-->
    <!--<span *ngIf="status === WebStatsStatus.QUALIFIED" class="web-stats-icon text-success">-->
    <!--<i class="fas fa-check" aria-hidden="true"></i>-->
    <!--</span>-->
    <!--<span *ngIf="status === WebStatsStatus.NOT_QUALIFIED" class="web-stats-icon text-danger">-->
    <!--<i class="fas fa-times" aria-hidden="true"></i>-->
    <!--</span>-->
    <!--</cm-popover-action>-->
    <!--<cm-popover-content>-->
    <!--<div class="web-stats">-->
    <!--<h5 class="web-stats-domain">{{domain || ''}}</h5>-->
    <!--<small>-->
    <!--Visits / Bounce rate / Avg. visit duration-->
    <!--</small>-->
    <!--<p>-->
    <!--<span>{{visits | number: '1.0-0'}}</span>-->
    <!--<span>{{bounceRate || 0 | percent}}</span>-->
    <!--<span>{{(formatSeconds(visitDuration || 0))}} </span>-->
    <!--</p>-->
    <!--</div>-->
    <!--</cm-popover-content>-->
    <!--</cm-popover>-->
    <span (click)="dialog()">
      <span *ngIf="status === WebStatsStatus.PENDING" class="web-stats-icon text-warning">
          <i class="fas fa-minus" aria-hidden="true"></i>
        </span>
        <span *ngIf="status === WebStatsStatus.QUALIFIED" class="web-stats-icon text-success">
          <i class="fas fa-check" aria-hidden="true"></i>
        </span>
        <span *ngIf="status === WebStatsStatus.NOT_QUALIFIED" class="web-stats-icon text-danger">
          <i class="fas fa-times" aria-hidden="true"></i>
        </span>
    </span>
    <!--<mat-menu #menu="matMenu" class="list-only list-only&#45;&#45;webstats">-->
    <!--<button mat-menu-item [disableRipple]="true">-->
    <!--<div class="web-stats">-->
    <!--<h5 class="web-stats-domain">{{domain.name || ''}}</h5>-->
    <!--<small>-->
    <!--Visits / Bounce rate / Avg. visit duration-->
    <!--</small>-->
    <!--<p>-->
    <!--<span>{{visits | number: '1.0-0'}}</span>-->
    <!--<span>{{bounceRate || 0 | percent}}</span>-->
    <!--<span>{{(formatSeconds(visitDuration || 0))}} </span>-->
    <!--</p>-->
    <!--</div>-->
    <!--</button>-->
    <!--</mat-menu>-->
  `,
  styleUrls: ['./web-stats-status-icon.component.scss']
})
export class WebStatsStatusIconComponent {

  @Input()
  public status: WebStatsStatus;

  @Input()
  public showDetailsPopover = true;

  @Input()
  bounceRate: number;

  @Input()
  domain: Domain;

  @Input()
  visitDuration: number;

  @Input()
  visits: number;

  WebStatsStatus = WebStatsStatus;
  WebStatsStatusLabels = WebStatsStatusLabels;

  constructor(private matDialog: MatDialog) {
  }

  dialog() {
    this.matDialog.open(KnDomainWebStatsDialogComponent, <MatDialogConfig>{
      data: {
        domain: this.domain
      },
      width: '600px'
    });
  }

  formatSeconds(time) {
    if (!time) return;
    time = Math.round(time);
    // Hours, minutes and seconds
    const hrs = ~~(time / 3600);
    const mins = ~~((time % 3600) / 60);
    const secs = time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = '';

    if (hrs > 0) {
      ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
    }

    ret += '' + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;
    return ret;
  }

}
